/**
 * @generated SignedSource<<088cbba2ae7e6d2c8771df94f53e0e12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoToolbarButtonTags_tags$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"TodoTagButtonContentActive_todoCategoryTag">;
  readonly " $fragmentType": "TodoToolbarButtonTags_tags";
}>;
export type TodoToolbarButtonTags_tags$key = ReadonlyArray<{
  readonly " $data"?: TodoToolbarButtonTags_tags$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTags_tags">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoToolbarButtonTags_tags",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoTagButtonContentActive_todoCategoryTag"
    }
  ],
  "type": "TodoCategoryTag",
  "abstractKey": null
};

(node as any).hash = "77cc8fb4788af08c869de038184ea4af";

export default node;
